import React, { useState } from 'react';
import { Row, Col, Container, Form } from 'react-bootstrap';

// Consumer Widgets
import ConsumptionOverviewWidget from '../components/dashboard-widgets/consumptionOverview';
import PastSixMonthsWidget from '../components/dashboard-widgets/pastSixMonthWidget';
import BreakdownWidget from '../components/dashboard-widgets/breakdownWidget';

// Produmer Widgets
import GreenEnergyTransaction from '../prosumerComponents/dashboard-widgets/greenEnergyTransaction';
//import PastSixMonths from '../prosumerComponents/dashboard-widgets/pastSixMonthWidget';
import Production from '../prosumerComponents/dashboard-widgets/production';
// import { useAppSelector } from '../app/hooks';
// import { AuthUser, selectUser } from '../slices/auth.slice';
import GreenEnergyDistribution from '../prosumerComponents/dashboard-widgets/greenEnergyDistribution';
import AdminGreenAtributeTransaction from '../components/admin-dashbord/admingreenAtributeTransation';
import AdminProduction from '../components/admin-dashbord/adminProduction';
import AdminGreenAtributeTransactionSeparate from '../components/admin-dashbord/admingreenAtributeTransationSeperate';
//import AdminTransactions from '../components/admin-dashbord/adminTransactions';
import Transactions from '../components/admin-dashbord/adminTransactions';
import ProsumerProduction from '../prosumerComponents/dashboard-widgets/prosumerProduction';

function Dashboard() {
  //let authUser: AuthUser = useAppSelector(selectUser);
  const auth = JSON.parse(localStorage.getItem('auth')!);

  const [showPremiseAddress, setShowPremiseAddress] = useState(false);
  // const [userIdList, setUserIdList] = useState<number[]>(() => {
  //   return auth?.mappedPremises.map((item: any) => item.userId);
  // })

  const findDashboardName = (): string => {
    if (auth?.userType === 'Consumer')
      return 'Customer Dashboard';
    if (auth?.userType === 'Producer')
      return 'Generator Dashboard';
    if (auth?.userType === 'Prosumer')
      return 'Prosumer Dashboard';
    return 'Administrator Dashboard';
  }

  let dashboardName: string = findDashboardName();

  const [selectedPremiseId, setSelectedPremiseId] = useState<any>(() => {
    if (auth?.mappedPremises?.length === 1)
      return auth?.location?.PremiseID;
    return '0';
  });
  const [selectedPremise, setSelectedPremise] = useState();

  const handlePremiseChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedPremiseId(event.target.value);
    (event.target.value === '0') ? setShowPremiseAddress(false) : setShowPremiseAddress(true);
    const mappedPremise = auth?.mappedPremises?.find((item: any) => item.premise.PremiseID.toString() === event.target.value);
    setSelectedPremise(mappedPremise?.premise);
  }

  let userIdList: number[] = [];
  if (showPremiseAddress) {
    userIdList.push(auth?.mappedPremises
      .find((item: any) => item.premise.PremiseID.toString() === selectedPremiseId).userId);
  } else {
    userIdList = auth?.mappedPremises.map((item: any) => {
      console.log(`User id is : ${JSON.stringify(item)}`);
      return item.userId
    });
  }

  return (
    <Container className='mt-4'>
      <Row>
        <Col lg="6"><h1 className='mb-0'>{dashboardName}</h1></Col>
        <Col lg="6">
          {(auth?.mappedPremises?.length === 1) ? <Col></Col> :
            <Col lg="8" className=''>
              <label htmlFor="prosumers">
                <Form.Select
                  onChange={(e) => handlePremiseChange(e)}
                  value={selectedPremiseId}
                  className='selectBox'
                  style={{ marginRight: '25px' }}
                  size="lg"
                  aria-label="Default select example">
                  <option value={'0'}>ALL</option>
                  {auth?.mappedPremises?.map((item: any) => (
                    <option key={item.premise.PremiseID} value={item.premise.PremiseID}>{item.premise.BuildingName}</option>
                  ))}
                </Form.Select>
              </label></Col>}
        </Col>
      </Row>

      <Row className='mb-3'>
        <Col lg="6">
          {
            (auth?.mappedPremises?.length === 1) ? <p className='color-light'>
              Premise Address:  {auth?.location?.BuildingNumber} {auth?.location?.BuildingName} {auth?.location?.Floor ? 'Floor ' + auth?.location?.Floor : null} {auth?.location?.StreetAddress} {auth?.location?.City} {auth?.location?.ZipCode}</p> :
              (showPremiseAddress) ? <p className='color-light'>
                Premise Address: {selectedPremise?.['BuildingNumber']} {selectedPremise?.['BuildingName']} {selectedPremise?.['Floor'] ? 'Floor ' + selectedPremise?.['Floor'] : null} {selectedPremise?.['StreetAddress']} {selectedPremise?.['City']} {selectedPremise?.['ZipCode']}
              </p> : <></>
          }
        </Col>
        <Col lg="6" className='text-lg-end text-start'><small className='color-light'>Last updated 30 mins ago</small></Col>
      </Row>
      <Row>
        <Col lg="6">
          {
            auth?.userType === 'Consumer' ? <ConsumptionOverviewWidget userList={userIdList} /> :
              auth?.userType === 'Producer' ? <GreenEnergyTransaction /> :
                auth?.userType === 'Admin' ? <AdminGreenAtributeTransaction /> :
                  auth?.userType === 'Prosumer' ? <GreenEnergyTransaction /> : <></>
          }
        </Col>
        <Col lg="6" className='mt-4 mt-lg-0'>
          {
            auth?.userType === 'Consumer' ? <PastSixMonthsWidget userList={userIdList} /> :
              auth?.userType === 'Producer' ? <GreenEnergyDistribution /> :
                auth?.userType === 'Admin' ? <GreenEnergyDistribution /> :
                  auth?.userType === 'Prosumer' ? <GreenEnergyDistribution /> : <></>
          }
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col>
          {
            auth?.userType === 'Admin' ? <AdminGreenAtributeTransactionSeparate /> : <></>
          }
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col>
          {
            auth?.userType === 'Consumer' ? <BreakdownWidget userList={userIdList} /> :
              auth?.userType === 'Producer' ? <Production /> :
                auth?.userType === 'Admin' ? <AdminProduction /> :
                  auth?.userType === 'Prosumer' ? <ProsumerProduction /> : <></>
          }
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col>
          {
            (auth?.userType === 'Prosumer' || auth?.userType === 'Producer' || auth?.userType === 'Consumer') ?
              <Transactions
                userIds={userIdList}
                userType={auth?.userType} /> :
              <></>
          }
        </Col>
      </Row>
    </Container>
  );
}
export default Dashboard;
